// Third party
import Cookies from 'js-cookie';

// Shopify
import {AddressForm} from '@shopify/theme-addresses';

// Bluegg Local Modules
import {cart} from "./modules/cart.js";
import {search} from "./modules/search.js";
import {atoz} from "./modules/atoz.js";
import {searchResults} from "./modules/search-results.js";
import {emailCapture} from "./modules/email-capture.js";
import meganav from "./modules/meganav.js";
import lazy from './modules/lazy-loading';
import {gaEvents, addGaEvents} from './modules/ga-events';
import {cardScores} from './modules/reviews.js';

// Lazyloading

window.lazy = lazy;

window.lazy.init();

// If we are in the theme editor, whenevr a section is edited/loads re run the lazy load for images to updated
if (window.Shopify.designMode) {
	document.addEventListener('shopify:section:load', (event) => {		   
		window.lazy.init();
	});
}

// Sign up forms

const isOutsideEU = document.querySelector('body').classList.contains('character-non-eu');

if (Cookies.get('cookieconsent_status') || isOutsideEU) {
	emailCapture();
} else {
	var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
            // element added to DOM
            var hasClass = [].some.call(mutation.addedNodes, function(el) {
								if (el.classList) {
									return el.classList.contains('cc-window');
								}
								return false;
            });
            if (hasClass) {
                // element has class `MyClass`
								const ccTriggers =  [document.querySelector('.cc-allow'), document.querySelector('.cc-btn-accept-selected'), document.querySelector('.cc-btn-accept-all')]

								document.addEventListener('click', (e) => {
									if (ccTriggers.includes(e.target)) {
										window.setTimeout(() => {
											emailCapture();
										}, 2000)
									}
								})
								
								// stop observing
								observer.disconnect();
            }
        }
    });
	});

	var config = {
			attributes: true,
			childList: true,
			characterData: true
	};

	observer.observe(document.body, config);

}

// nav
meganav({
	hover: true
});

const azNav = document.getElementById('a-z-nav');
if (azNav) {
	atoz();
}

// search 
search();

if (document.getElementById('search-results-collections')) {
	searchResults();
}

// For address forms
var addressForm = document.querySelector('[data-address=root]');

if (addressForm) {
  // Fill in country and provinces
  AddressForm(addressForm, 'en');
}

// Reviews
window.cardScores = cardScores;
cardScores();

// Cart JS
if (document.querySelector('[action="/cart"]') != null) {
	cart();
}

// GA Events
gaEvents();

window.addGaEvents = addGaEvents;

